import { heroStats } from "@/mocks/siteData";

type HeroProps = {
  onOpenConsult: () => void;
};

export default function Hero({ onOpenConsult }: HeroProps) {
  return (
    <section id="hero" className="sticky top-0 h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20abstract%20composition%20blending%20law%20and%20finance%20concepts%2C%20elegant%20brass%20scales%20of%20justice%20silhouette%20beside%20faint%20glowing%20stock%20chart%20lines%20and%20stacked%20law%20book%20shapes%2C%20deep%20charcoal%20background%20with%20warm%20golden%20amber%20light%20rays%2C%20soft%20mist%20texture%2C%20stylized%20artistic%20minimalism%2C%20premium%20professional%20legal%20brand%20atmosphere%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=yeonan-hero-legal-finance-02&orientation=landscape&nocache=true"
          alt="연안법무법인 도산·회생 전문 법률 상담 배경 이미지"
          title="연안법무법인 개인회생 개인파산 전문 상담"
          className="h-full w-full object-cover object-top"
        />
        <div className="hero-legal-pattern absolute inset-0" />
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
          <i className="ri-scales-3-line text-[34rem] leading-none text-primary-500/[0.05] lg:text-[46rem]" />
        </div>
        <div className="absolute inset-0 bg-background-50/45" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/25 to-background-50/95" />
      </div>

      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center">
        <div className="flex items-center gap-3 animate-float-slow">
          <span className="h-px w-8 bg-primary-500/70" />
          <span className="font-label text-xs md:text-sm text-primary-400">
            Yeonan Law Firm · Insolvency
          </span>
          <span className="h-px w-8 bg-primary-500/70" />
        </div>

        <h1 className="font-heading mt-6 text-[1.75rem] leading-[1.3] text-foreground-950 sm:text-4xl sm:leading-[1.35] md:text-6xl lg:text-7xl">
          무너진 일상,
          <br />
          <span className="text-primary-400">연안</span>과 다시 세우다
        </h1>

        <p className="mt-6 max-w-2xl text-sm md:text-lg leading-relaxed text-foreground-600">
          도산 분야를 집중적으로 다루는 연안법무법인의 전문 변호사가
          <br className="hidden sm:block" />
          상담부터 인가·면책까지 처음부터 끝까지 함께합니다.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2 md:gap-3">
          {heroStats.map((stat) => (
            <span
              key={stat.value}
              className="rounded-full border border-primary-800/50 bg-primary-950/40 px-4 py-2 text-xs md:text-sm text-foreground-700"
            >
              <b className="font-medium text-primary-400">{stat.value}</b>
              <span className="ml-2 text-foreground-500">{stat.label}</span>
            </span>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:gap-4">
          <button
            type="button"
            onClick={onOpenConsult}
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-medium text-background-50 transition-colors duration-300 hover:bg-primary-600 cursor-pointer sm:w-auto"
          >
            무료 상담예약
          </button>
          <a
            href="#diagnosis"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-700/40 px-8 py-3.5 text-sm text-foreground-800 transition-colors duration-300 hover:border-primary-500 hover:text-primary-400 cursor-pointer sm:w-auto"
          >
            자가진단 하기
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>

      <a
        href="#about"
        className="absolute bottom-8 left-1/2 hidden -translate-x-1/2 flex-col items-center gap-2 md:flex cursor-pointer"
      >
        <span className="font-label text-[10px] text-foreground-500">Next</span>
        <span className="relative block h-10 w-px overflow-hidden bg-foreground-700/30">
          <span className="animate-hero-index absolute inset-x-0 top-0 block h-4 bg-primary-500" />
        </span>
      </a>
    </section>
  );
}